export default __webpack_public_path__ + "static/salmon-8617f10b53abef167025b2d61a0aaef3.jpeg";